import { SmartViewInlineActions } from '../../../../grid/gridSmartViews/types';
import { Column, Filter } from '../../integrityMonitorRulesGrid/types';
import { IntegrityMonitorIdentifier } from '../../../common/utils/types';

export interface IntegrityMonitorSmartViewData {
  ruleSetIdentifiers: Array<IntegrityMonitorIdentifier>;
  activeViewId: string;
}

export interface SmartViewInfo extends IntegrityMonitorIdentifier {
  displayedColumns: Array<Column>;
  filters: Array<Filter>;
}

export enum IntegrityMonitorSpecificInlineActions {
  EDIT = 'edit',
  ADD_TO_POLICY = 'addToPolicy',
}

export const IntegrityMonitorInlineActions = {
  ...SmartViewInlineActions,
  ...IntegrityMonitorSpecificInlineActions,
};

export enum DefaultSmartViewId {
  ALL_RULES = 'allRules',
  DEFAULT_OS_RULES = 'defaultOsRules',
  DEFAULT_APPLICATION_RULES = 'defaultApplicationRules',
  CUSTOM_RULES = 'customRules',
}

export enum ViewType {
  ALL_RULES = 1,
  DEFAULT_OS_RULES = 2,
  DEFAULT_APPLICATION_RULES = 3,
  CUSTOM_RULES = 4,
  RULE_SET = 5,
}

export const MappingViewIdToType = {
  [DefaultSmartViewId.ALL_RULES]: ViewType.ALL_RULES,
  [DefaultSmartViewId.DEFAULT_OS_RULES]: ViewType.DEFAULT_OS_RULES,
  [DefaultSmartViewId.DEFAULT_APPLICATION_RULES]: ViewType.DEFAULT_APPLICATION_RULES,
  [DefaultSmartViewId.CUSTOM_RULES]: ViewType.CUSTOM_RULES,
};
